// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item {
  width: auto;
  height: auto;
  margin: 10px auto;
  padding: 10px;
}

.fb-item {
  width: auto;
  height: auto;
  margin: 10px auto;
  padding: 10px;
}

.gravatar {
  width: 100px;
  height: 90px;
}

.gravatar-title {
  width: 500px;
  padding: 10px;
  height: 80px;
}

.first-section-wrapper,
.second-section-wrapper {
  width: 100%;
  height: auto;
  flex: 1;
}

.first-section-wrapper {
  display: flex;
  justify-content: center;
}

.second-section-wrapper {
  margin-top: 30px;
}

.wrapper {
  width: 100%;
  flex: 1;
}

.item-with-background {
  background: #121212;
  padding: 10px;
}

.loader {
  line-height: 1;
  box-sizing: border-box;
  background-repeat: no-repeat;
  background: rgb(239, 241, 246) no-repeat;
  background-color: rgb(239, 241, 246);
  line-height: 1;
  overflow: hidden;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/component/skelton-frame/skelton-frame.component.scss"],"names":[],"mappings":"AACA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;AAAJ;;AAGE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;AAAJ;;AAGE;EACE,YAAA;EACA,YAAA;AAAJ;;AAEE;EACE,YAAA;EACA,aAAA;EACA,YAAA;AACJ;;AAEE;;EAEE,WAAA;EACA,YAAA;EACA,OAAA;AACJ;;AAEE;EACE,aAAA;EACA,uBAAA;AACJ;;AAEE;EACE,gBAAA;AACJ;;AAEE;EACE,WAAA;EACA,OAAA;AACJ;;AAEE;EACE,mBAAA;EACA,aAAA;AACJ;;AAEE;EACE,cAAA;EACA,sBAAA;EACA,4BAAA;EAAgC,wCAAA;EAChC,oCAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAEJ","sourcesContent":["\r\n.item {\r\n    width: auto;\r\n    height: auto;\r\n    margin: 10px auto;\r\n    padding: 10px;\r\n  }\r\n  \r\n  .fb-item {\r\n    width: auto;\r\n    height: auto;\r\n    margin: 10px auto;\r\n    padding: 10px;\r\n  }\r\n  \r\n  .gravatar {\r\n    width: 100px;\r\n    height: 90px;\r\n  }\r\n  .gravatar-title {\r\n    width: 500px;\r\n    padding: 10px;\r\n    height: 80px;\r\n  }\r\n  \r\n  .first-section-wrapper,\r\n  .second-section-wrapper {\r\n    width: 100%;\r\n    height: auto;\r\n    flex: 1;\r\n  }\r\n  \r\n  .first-section-wrapper {\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .second-section-wrapper {\r\n    margin-top: 30px;\r\n  }\r\n  \r\n  .wrapper {\r\n    width: 100%;\r\n    flex: 1;\r\n  }\r\n  \r\n  .item-with-background {\r\n    background: #121212;\r\n    padding: 10px;\r\n  }\r\n  \r\n  .loader {\r\n    line-height: 1;\r\n    box-sizing: border-box;\r\n    background-repeat: no-repeat;\t  background: rgb(239, 241, 246) no-repeat;\r\n    background-color: rgb(239, 241, 246);\t\r\n    line-height: 1;\t\r\n    overflow: hidden;\t\r\n    position: relative;\r\n  }\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
